import {ListTabsPanel} from 'common/components'
// import styles from './TopPanel.module.scss'

const tabs = [
  {key: '',             label: 'Roles'},
  {key: 'users',        label: 'Users'},
]

export default function TopPanel() {
  return (
    <ListTabsPanel
      noGap
      path="rbac"
      tabs={tabs}
      // action={}
    />
  )
}
